// extracted by mini-css-extract-plugin
export var title = "index-module--title--AHsrX";